import React from 'react';

const BackArrow = ({className,onClick}) => {
    return (
        <svg className={className} onClick={onClick} width="42" height="78" viewBox="0 0 42 78" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M38.9909 3L3 39L39 75" stroke="red" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default BackArrow;
